import { supplierIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { Supplier } from "./get-suppliers";

export const getSupplier = {
  name: "getSupplier" as const,
  input: z.object({ supplierId: supplierIdFormat.schema }),
  output: z.object({ supplier: Supplier }),
};
